import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import AreaForm from "./AreaForm";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import useDeleteArea from "./hooks/useDeleteArea";
import useUpdateArea from "./hooks/useUpdateArea";
import {
  addStateArea,
  selectedRowsStateArea,
  setFilterTextArea,
  editStateArea,
  rowForEditStateArea,
  setCheckStatusStateArea,
  disableButtonStateArea,
  rowEditIdStateArea,
  setLinkStateArea,
  setButtonLinkTextStateArea,
  setHierarchyIdStateArea,
  setHiddenColumnStateArea,
  setDescriptionAreaState,
} from "../../OfficeHierarchy/Area/atoms/atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import useGetEmployees from "./hooks/useGetEmployees";
import { getHierarchyType } from "./../atoms/atoms";
import { useOfficeHierarchyChildByTypeId } from "./../hooks/useOfficeHierarchyChildByTypeId";
const AreaTable = ({ areaRowData, onClickOfficeHierarchyName }) => {
  //Hooks Call
  const { data, isFetching } = useOfficeHierarchyChildByTypeId(
    "Area",
    areaRowData.idC
  );

  const UpdateArea = useUpdateArea();
  const BulkDeleteArea = useDeleteArea();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateArea);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsStateArea);
  const [rowForEdit, setRowForEdit] = useRecoilState(rowForEditStateArea);
  const [filterText, setFilterText] = useRecoilState(setFilterTextArea);
  const [editRowId, setEditRowId] = useRecoilState(rowEditIdStateArea);
  const [actionEditState, setActionEditState] = useRecoilState(editStateArea);
  const [disabledButton, setDisabledButton] = useRecoilState(
    disableButtonStateArea
  );
  const [, setDescription] = useRecoilState(setDescriptionAreaState);
  const [, setType] = useRecoilState(getHierarchyType);
  const [checkStatus, setCheckStatus] = useRecoilState(setCheckStatusStateArea);
  const [, setButtonTextLinkState] = useRecoilState(setButtonLinkTextStateArea);
  const [, setButtonLinkState] = useRecoilState(setLinkStateArea);
  const [, setHierarchyId] = useRecoilState(setHierarchyIdStateArea);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [empTypeIsExist, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasArea, setHasArea] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [displayNote, setDisplayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [hideColumn, sethideColumn] = useRecoilState(setHiddenColumnStateArea);
  const userAccount = useRecoilState(accountAtom);
  const [areaFilteredData, setAreaFilteredData] = useState([]);
  const employeeList = useGetEmployees();

  const viewPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_area_view;

  const defaultValues = {
    areaId: 0,
    areaCode: "",
    areaName: "",
    areaManager: "",
    managerEmail: "",
    managerUltiproNumber: "",
    areaId: 0,
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    isActive: 0,
  };
  const [empNewData] = useState([defaultValues]);
  const editPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_area_edit;
  const addPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_area_add;
  const userPermissions = useRecoilValue(permissionsSelector);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent != "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setAreaFilteredData(result);
          setButtonTextLinkState(recordIdFromRecent.subModuleName);
          if (
            recordIdFromRecent.subModuleName === "Add" ||
            recordIdFromRecent.subModuleName === "Edit"
          ) {
            setType(recordIdFromRecent.selectedType);
            setDescription(recordIdFromRecent.description);
            setHierarchyId(recordIdFromRecent.hierarchyId);

            setActionAddState(true);
            setButtonLinkState(true);
          }
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleEditButton = (rowData) => {
    setAreaFilteredData([]);
    setRowForEdit(rowData);
    setEditRowId(rowData.areaId);
    setEmpTypeDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    sethideColumn(true);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.areaId);
    BulkDeleteArea(ids);
    setActionEditState(false);
    setActionAddState(false);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Areas" : "Area"
    } ?`}</div>
  );

  const matColumns = [
    {
      title: "Name",
      field: "officeHierarchyName",
      // headerStyle: { borderLeft: "4px solid #203A75" },
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => onClickOfficeHierarchyName(rowdata)}
          >
            <span className="blueAndBold underline ">
              {rowdata.officeHierarchyName}
            </span>
          </div>
        );
      },
      cellStyle: {
        textAlign: "left",
        width: "30%",
        fontSize: "12px",
      },
    },

    {
      title: "Type",
      field: "Type",
      hidden: hideColumn,
      render: (rowData) => {
        return <div className="font-sans mr-4 text-xs">{rowData.type}</div>;
      },
    },
    {
      title: "Code",
      field: "areaCode",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans text-left mr-4 text-xs">
            {rowData.hierarchyCode}
          </div>
        );
      },
    },
    {
      title: "Manager",
      field: "areaManager",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans mr-4 text-xs">{rowData.managerName}</div>
        );
      },
    },
    {
      title: "Is Active",
      field: "status",
      render: (rowData) => {
        return (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                checked={rowData.isActive ? true : false}
                //   onClick={(e) => {
                //     setIsChecked(e.target.checked);
                //     handleCheckBox(e);
                //   }
                // }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Record Type",
      field: "recordType",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans mr-4 text-xs">{rowData.recordType}</div>
        );
      },
    },
    // {
    //   title: "Action/s",
    //   align: "center",
    //   render: (rowData) => {
    //     return (
    //       <div className="grid grid-col-1 justify-items-center mr-6">
    //         {userPermissions.includes(editPermission) ? (
    //           <Button
    //             disabled={disabledButton || selectedRows.length > 0}
    //             className={
    //               disabledButton || selectedRows.length > 0
    //                 ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
    //                : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
    //             }
    //             onClickFunction={() => {
    //               setActionEditState(true);
    //               handleEditButton(rowData);
    //               setButtonLinkState(false);
    //             }}
    //           >
    //             <PencilSquareIcon className="h-4 w-4" />
    //             <div>Edit</div>
    //           </Button>
    //         ): (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];

  //Filters
  const filteredItems = data
    ? data
    : // .filter(
      //     (item) =>
      //       item.areaName &&
      //       item.areaName.toLowerCase().includes(filterText.toLowerCase())
      //   )
      [];

  return (
    <div className="">
      <div className="">
        {!actionAddState && !actionEditState && (
          <div className="">
            <div className="flex w-full">
              <div className="bg-white w-full">
                {/* <div className="font-bold text-primary text-xl uppercase mx-4 ">
                  {" "}
                  <h1>Area</h1>{" "}
                </div> */}
                <div className="flex justify-between text-xs items-center w-full px-4 mt-2 ">
                  {/* <div className="">
                    <TableFilters
                      filterText={setFilterText}
                      moduleDetails="Area Name"
                      textInputName="AreaName"
                      disabledButton={disabledButton || selectedRows.length > 0}
                    ></TableFilters>
                  </div> */}
                  <div className="ml-auto">
                    {/* {userPermissions.includes(addPermission) ? (
                      <AddButton
                        buttonText="New Area"
                        className={
                          selectedRows.length > 0 || actionEditState
                            ? "opacity-50"
                           : "opacity-100"
                        }
                        onClick={() => {
                          setActionAddState(!actionAddState);
                          setButtonLinkState(false);
                        }}
                        disabled={disabledButton}
                      />
                    ): (
                      ""
                    )} */}
                  </div>
                </div>
                {/* <div>
                  {(userPermissions.includes(viewPermission) && !displayNote) ||
                  (userPermissions.includes(viewPermission) && !displayNote) ? (
                    <div className="text-secondary italic text-xs3  mt-2 mx-4 ">
                      {!actionEditState ? (
                        <div>
                          <p className="font-bold italic inline-block mr-1">
                            Note:{" "}
                          </p>
                          Tick the box to deactivate some data.
                        </div>
                      ): (
                        <div></div>
                      )}
                    </div>
                  ): (
                    ""
                  )}
                </div> */}
                <div className="p-4">
                  <MaterialExTable
                    columns={matColumns}
                    data={
                      data
                      // ? areaFilteredData.length > 0
                      //   ? areaFilteredData
                      //  : filterText === ""
                      //   ? data.map((data) => ({ ...data }))
                      //  : filteredItems
                      //: []
                    }
                    options={{
                      toolbar: false,
                      showTitle: false,
                    }}
                    // detailPanel={(rowData) => {
                    //   return (
                    //     <div className="">
                    //       <AreaExpandedRow
                    //         data={rowData}
                    //         editRow={actionEditState}
                    //         // HandleModalShow={HandleModalShow}
                    //       />
                    //     </div>
                    //   );
                    // }}
                    // selection={!actionEditState}
                    setOpenModal={setOpenModalDelete}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRows}
                    isDeactivate={true}
                    isLoading={isFetching}
                  />
                </div>
              </div>
            </div>
            <ConfirmBoxDelete
              ModalTitle="Deactivate Area"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        )}
        {actionAddState && (
          <div className=" ">
            <AreaForm employeeList={employeeList} />
          </div>
        )}
        {actionEditState && (
          <div className=" ">
            <AreaForm employeeList={employeeList} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AreaTable;
